<template>
  <div class="partner-page digio-page">
    <PartnersBanner :creditor="creditor" />
    <PartnersHowItWorks :creditor="creditor" />
    <HomeOurChannels
      iconsPath="partners/digio/"
      mobilePath="/images/partners/digio/m-our-channel.png"
      desktopPath="/images/partners/digio/our-channel.png"
      :isPartner="true"
    />
    <PartnersNeedHelp :creditor="creditor" />
    <HomeOurPartners :partnerName="creditor.name" :isPartner="true" />
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: "creditor",
});

const creditor = ref<CreditorProfile>({
  name: "Digio",
  alias: "digio",
  id: 1,
  chave: "digio",
});
</script>

<style lang="scss">
@use "@/styles/variables" as v;
@use "@/styles/partners/digio" as d;

.digio-header {
  .content .creditor-logo {
    max-width: 81px;
    max-height: 36px;
    width: 100%;
    height: 100%;
    margin-right: 17px;

    @media screen and (min-width: 834px) and (max-width: 959px) {
      max-width: 100px;
      max-height: 44.4px;
      margin-right: 28px;
    }

    @media screen and (min-width: 960px) {
      max-width: 100px;
      max-height: 44.4px;
      margin-right: 30px;
    }
  }
}

.digio-page {
  .text-chip {
    background-color: d.$primaryColor !important;
    color: v.$white !important;
  }

  .title {
    color: d.$textColor !important;
    font-family: "Open Sans";
    font-weight: 800;
  }

  .partner-banner-section {
    background-image: url(@/assets/images/partners/digio/bg-banner.png);
    background-position: 45% top;

    .wrapper {
      .banner-content {
        .banner-button {
          background-color: d.$secondaryColor;
          margin: 0px auto 16px;

          &:hover {
            background-color: d.$buttonHover;
          }
        }
      }

      @media screen and (min-width: 834px) and (max-width: 1199px) {
        .banner-content {
          .banner-title {
            width: 347px;
          }

          .banner-button {
            margin: 0px 0px 69px;
          }
        }
      }

      @media screen and (min-width: 960px) and (max-width: 1199px) {
        padding: 0px 32.5px;

        .image-component img {
          width: 522px;
        }
      }

      @media screen and (min-width: 960px) {
        .banner-content {
          .banner-text {
            width: 90%;
          }
        }
      }

      @media screen and (min-width: 1200px) {
        .banner-content {
          .banner-text {
            margin: 28px 0px;
            width: 438px;
            max-width: none;
          }

          .banner-button {
            margin: 0px 0px 134.7px;
          }
        }
      }
    }
  }

  .partner-how-works-section {
    .steps {
      .default-card .step-counter {
        background-color: d.$tertiaryColor;
      }
    }
  }

  .our-channels-section.partner-page {
    .content-text .channels .channel {
      &:nth-child(1),
      &:nth-child(2) {
        height: 142px;
      }
    }

    @media screen and (min-width: 1200px) {
      padding: 68px 0px;
    }
  }

  .need-help-section {
    .the-faq-list {
      .panels {
        .panel {
          .v-expansion-panel-title {
            &:hover {
              color: d.$primaryColor;
            }

            .mdi {
              color: d.$primaryColor;
            }
          }

          .v-expansion-panel-title--active {
            color: d.$primaryColor;
          }

          &:hover {
            border-color: d.$primaryColor;
          }
        }

        .v-expansion-panel--active {
          border-color: d.$primaryColor !important;
        }
      }
    }

    .talk-button {
      background-color: d.$secondaryColor;
      color: v.$white;

      &:hover {
        background-color: d.$buttonHover !important;
      }
    }
  }

  .our-partners-section.partner-page {
    .content .content-sheet .creditors .creditor-block .creditor-logo:hover {
      border-color: d.$primaryColor;
      box-shadow: 0px 6px 15px d.$dropShadow !important;
    }
  }
}
</style>
